import { Avatar } from "antd";
import type { CSSProperties } from "react";

interface UserAvatarProps {
  name: string;
  avatar?: string | null;
  size?: number;
  onClick?: () => void;
  style?: CSSProperties;
}

export function UserAvatar({ name, avatar, size = 32, onClick, style }: UserAvatarProps) {
  const firstChar = name ? name[0].toUpperCase() : "?";

  if (avatar) {
    return (
      <Avatar
        src={avatar}
        size={size}
        onClick={onClick}
        style={{ cursor: onClick ? "pointer" : undefined, flexShrink: 0, ...style }}
      />
    );
  }

  return (
    <Avatar
      size={size}
      onClick={onClick}
      style={{
        backgroundColor: "var(--avatar-default-bg, #3B8FC4)",
        color: "#fff",
        cursor: onClick ? "pointer" : undefined,
        fontWeight: 600,
        fontSize: size * 0.45,
        flexShrink: 0,
        ...style,
      }}
    >
      {firstChar}
    </Avatar>
  );
}
